import {Directive, ViewContainerRef} from "@angular/core";

@Directive({
    selector: '[resultsHost]',
})
export class ResultsDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
